export default __webpack_public_path__ + "static/media/IMG_5125.fd3eb1cf.jpeg";